import { Controller } from 'stimulus';

class Ticket extends Controller {
  connect() {
    this.element.classList.add('is-visible');

    this.element.addEventListener('click', () => {
      this.element.classList.remove('is-visible');

      setTimeout(() => {
        this.element.style.display = 'none';
      }, 2000);
    });

    if (this.hasPaperTarget) {
      setTimeout(() => {
        this.paperTarget.classList.add('is-visible');
      }, 100);

      setTimeout(() => {
        this.paperTarget.classList.add('is-hoverable');
      }, 1000);
    }
  }

  onMouseMove(event) {
    const xPercentage = event.x / window.innerWidth;
    const yPercentage = event.y / window.innerHeight;

    let classToAdd = '';

    if (xPercentage < 0.5 && yPercentage < 0.5) {
      classToAdd = 'direction--tl';
    } else if (xPercentage >= 0.5 && yPercentage < 0.5) {
      classToAdd = 'direction--tr';
    } else if (xPercentage < 0.5 && yPercentage >= 0.5) {
      classToAdd = 'direction--bl';
    } else if (xPercentage >= 0.5 && yPercentage >= 0.5) {
      classToAdd = 'direction--br';
    }

    this.paperTarget.className = this.paperTarget.className
      .replace(/direction--\w{2}/, '');

    this.paperTarget.classList.add(classToAdd);
  }
}

Ticket.targets = [
  'paper',
];

export default Ticket;
